export const searchConstants = {
  FETCH_COUNT_REQUEST: 'SEARCH_COUNT_FETCH_REQUEST',
  FETCH_COUNT_SUCCESS: 'SEARCH_COUNT_FETCH_SUCCESS',
  FETCH_COUNT_FAILURE: 'SEARCH_COUNT_FETCH_FAILURE',
  FETCH_REQUEST: 'SEARCH_FETCH_REQUEST',
  FETCH_SUCCESS: 'SEARCH_FETCH_SUCCESS',
  FETCH_FAILURE: 'SEARCH_FETCH_FAILURE',
};
